// removed by extract-text-webpack-plugin
module.exports = {"Beer":"Beer__Beer__-hash-base-64-5-","BeerBackdrop":"Beer__BeerBackdrop__-hash-base-64-5-","TextContainer":"Beer__TextContainer__-hash-base-64-5-","Name":"Beer__Name__-hash-base-64-5-","Tagline":"Beer__Tagline__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Beer/Beer.scss
// module id = 176
// module chunks = 0